<template>
  <div>
    <div class="view-npa-public">
      <v-container v-if="npa">
        <div class="breadcrumb-wrap">
          <v-breadcrumbs :items="breadcrumbs" />
        </div>
        <div class="position">
          <div class="bg-white p-20">
            <p style="color: darkred" class="title-view font-weight-medium" v-if="npa.npa.status.id === 9">
              {{ npa.npa.status.transName }}
            </p>
            <h1 class="title-view">
              {{ npa.npa.transName }}
            </h1>
            <div class="view-npa-head">
              <div class="view-npa-analytics">
                <v-row>
                  <div class="analytics-col">
                    <div class="subscripbe" v-if="isSubscribed === false">
                      <a @click="subscribe">
                        <img src="@/assets/subscibe.png" alt="subscibe" />
                        {{ $t('Подписаться') }}
                      </a>
                    </div>
                    <div class="subscripbe" v-else>
                      <a @click="unsubscribe">
                        <img src="@/assets/subscibe.png" alt="subscibe" />
                        {{ $t('Отписаться') }}
                      </a>
                    </div>
                    <div class="print-v">
                      <a href="#">
                        <img src="@/assets/print.png" alt="print" />
                        {{ $t('Версия для печати') }}
                      </a>
                    </div>
                    <div class="analytics">
                      <span class="views">
                        <i class="pro-icon-eye"></i>
                        {{ npa.npa.view_number }}
                      </span>
                      <span class="comments">
                        <i class="pro-icon-chat"></i>
                        {{ npa.commentsCnt }}
                      </span>
                      <span class="messages">
                        <i class="pro-icon-speech-bubble"></i>
                        {{ npa.answersCnt }}
                      </span>
                    </div>
                  </div>
                  <div class="analytics-col">
                    <div class="view-npa-status">
                      {{ npa.npa.status.transName }}
                      <div v-if="npa.npa.status.id === 9">
                        {{
                          new Date(npa.lastNpaHistory.date_accept)
                            | dateFormat('DD.MM.YYYY')
                        }}
                        {{ npa.lastNpaHistory.comment }}
                      </div>
                    </div>
                    <div class="history-project">
                      <v-menu
                        v-model="historiesMenu"
                        :close-on-content-click="false"
                        :nudge-width="200"
                        offset-y
                      >
                        <template v-slot:activator="{ on }">
                          <a v-on="on"
                            ><i class="pro-icon-clock-history"></i
                            >{{ $t('История проекта') }}</a
                          >
                        </template>
                        <v-list dense class="history-list">
                          <v-list-item
                            v-for="history in npa.npaHistories"
                            :key="history.id"
                            two-line
                          >
                            <v-list-item-content>
                              <v-list-item-title>
                                {{
                                  new Date(history.date)
                                    | dateFormat('DD.MM.YYYY')
                                }}
                                <template v-if="history.npa_stage">
                                  {{ history.npa_stage.npa_stages.transName }}
                                </template>
                                <template v-else>
                                  {{ history.status.transName }}
                                </template>
                              </v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </div>
                  </div>
                </v-row>
              </div>
              <div class="step-status" v-if="!npa.npa.initiativeStatus">
                <ul class="step-status__list">
                  <li :class="npa.publicStep.class">
                    <label>{{ $t('Публикация') }}</label>
                    <div class="step-icon">
                      <span class="pro-icon-play-button"></span>
                    </div>
                    <div class="step-date">
                      {{
                        new Date(npa.publicStep.date) | dateFormat('DD.MM.YYYY')
                      }}
                    </div>
                  </li>
                  <li :class="npa.discussStep.class">
                    <label>{{ $t('Обсуждение') }}</label>
                    <div class="step-icon">
                      <span class="pro-icon-comment"></span>
                    </div>
                    <div v-if="npa.discussStep.date" class="step-date">
                      {{ $t('до {date}', { date: dateDiscussStep }) }}
                      <div class="mt-n2" v-if="npa.npa.is_shortened">
                        {{ npa.npa.days_remaining_between }} {{$t('дней')}}
                      </div>
                    </div>
                  </li>
                  <li :class="npa.consideredStep.class">
                    <label>{{ $t('Рассмотрение') }}</label>
                    <div class="step-icon">
                      <span class="pro-icon-magnifying-glass"></span>
                    </div>
                    <div v-if="npa.consideredStep.date" class="step-date">
                      {{ $t('до {date}', { date: dateConsideredStep }) }}
                    </div>
                  </li>
                  <li :class="npa.reportStep.class">
                    <label>{{ $t('Отчёт') }}</label>
                    <div class="step-icon">
                      <span @click="editDialog" class="pro-icon-check"></span>
                    </div>
                    <template v-if="npa.reportStep.class === 'active'">
                      <div @click="editDialog" class="step-date">
                        {{ $t('Отчёт проекта НПА') }}
                      </div>
                      <NpaReport
                        v-bind:npaReportDialog.sync="npaReportDialog"
                        :npa="npa"
                        :dateDiscussStep="dateDiscussStep"
                      />
                    </template>
                  </li>
                </ul>
              </div>
              <NpaInitiative :npa="npa" @fetch-data="fetchData"/>
              <!--              Отключен до выяснения нужен данный блок или нет -->
              <!--              <div class="current-stage" v-if="npa.lastNpaHistory.npa_stage">-->
              <!--                <div class="current-status">-->
              <!--                  <template v-if="npa.lastNpaHistory.npa_stage">-->
              <!--                    <v-menu-->
              <!--                      v-model="npaStagePopup"-->
              <!--                      :close-on-content-click="false"-->
              <!--                      :nudge-width="200"-->
              <!--                      offset-y-->
              <!--                    >-->
              <!--                      <template v-slot:activator="{ on }">-->
              <!--                        <div>-->
              <!--                          <i class="pro-icon-clock-circular"></i>
                                            {{ $t('Текущая стадия') }}-->
              <!--                          <a class="status" v-on="on">-->
              <!--                            {{ npa.lastNpaHistory.npa_stage.npa_stages.transName }}-->
              <!--                          </a>-->
              <!--                        </div>-->
              <!--                      </template>-->
              <!--                      <v-card class="current-stage-card">-->
              <!--                        <v-list>-->
              <!--                          <v-list-item>-->
              <!--                            <v-list-item-content>-->
              <!--                              <v-list-item-title>{{ $t('Текущая стадия') }}</v-list-item-title>-->
              <!--                              <v-list-item-subtitle>-->
              <!--                                {{ npa.lastNpaHistory.npa_stage.npa_stages.transName }}-->
              <!--                              </v-list-item-subtitle>-->
              <!--                            </v-list-item-content>-->
              <!--                          </v-list-item>-->
              <!--                        </v-list>-->
              <!--                        <v-divider></v-divider>-->
              <!--                        <v-list class="current-stage-list">-->
              <!--                          <v-list-item>-->
              <!--                            <v-list-item-action-->
              <!--                            >{{ $t('Дата') }}:-->
              <!--                            </v-list-item-action>-->
              <!--                            <v-list-item-title>-->
              <!--                              {{-->
              <!--                                new Date(npa.lastNpaHistory.npa_stage.date)-->
              <!--                                  | dateFormat('DD.MM.YYYY')-->
              <!--                              }}-->
              <!--                            </v-list-item-title>-->
              <!--                          </v-list-item>-->
              <!--                          <v-list-item>-->
              <!--                            <v-list-item-action-->
              <!--                            >{{ $t('Стадия') }}:-->
              <!--                            </v-list-item-action>-->
              <!--                            <v-list-item-title>-->
              <!--                              {{ npa.lastNpaHistory.npa_stage.note }}-->
              <!--                            </v-list-item-title>-->
              <!--                          </v-list-item>-->
              <!--                        </v-list>-->
              <!--                      </v-card>-->
              <!--                    </v-menu>-->
              <!--                  </template>-->
              <!--                </div>-->
              <!--              </div>-->
            </div>
            <a
              class="npa-public-stage"
              v-if="npa.npaStatusConsiderationStage && npaPromotionHistory"
              @click="goToPromotionHistory"
            >
              {{ $t('Стадия') }}: {{ npaPromotionHistory.transName }}
            </a>
            <div class="view-npa-body">
              <table class="table-data">
                <tbody>
                  <tr>
                    <td>{{ $t('ID проекта') }}</td>
                    <td>{{ npa.npa.id }}</td>
                  </tr>
                  <tr>
                    <td>{{ $t('Дата публикации') }}</td>
                    <td>
                      {{
                        new Date(npa.npa.publish_date)
                          | dateFormat('DD.MM.YYYY')
                      }}
                    </td>
                  </tr>
                  <tr>
                    <td>{{ $t('Вид проекта НПА') }}</td>
                    <td>{{ npa.npa.view.transName }}</td>
                  </tr>
                  <tr v-if="npa.npa.region">
                    <td>{{ $t('Область') }}</td>
                    <td>{{ npa.npa.region.transName }}</td>
                  </tr>
                  <tr v-if="npa.npa.district">
                    <td>{{ $t('Район') }}</td>
                    <td>{{ npa.npa.district.transName }}</td>
                  </tr>
                  <tr>
                    <td>{{ $t('Редакция') }}</td>
                    <td>{{ npa.npa.edition.transName }}</td>
                  </tr>
                  <tr>
                    <td>{{ $t('Разработчик') }}</td>
                    <td>{{ npa.npa.developer.transName }}</td>
                  </tr>
                  <tr>
                    <td>{{ $t('Контактные лица') }}</td>
                    <td>
                      <ul class="">
                        <li v-for="(person, index) of npa.persons" :key="index">
                          <div>
                            {{ person.fullName }} {{ person.position }}
                            {{ person.phone }}
                          </div>
                        </li>
                      </ul>
                    </td>
                  </tr>
                  <tr v-if="npa.npa.initiator">
                    <td>{{ $t('Инициатор проекта НПА') }}</td>
                    <td>{{ npa.npa.initiator.transName }}</td>
                  </tr>
                  <tr>
                    <td>{{ $t('Категории') }}</td>
                    <td>
                      <div class="tags">
                        <template v-for="category in npa.npa.category">
                          <span class="tag" :key="category.id">{{
                            category.transName
                          }}</span>
                        </template>
                      </div>
                    </td>
                  </tr>
                  <tr v-if="npa.npa.is_shortened">
                    <td>{{ $t('Доп.мероприятия') }}</td>
                    <td>{{$t('Срок обсуждения:')}} {{npa.npa.days_remaining_between}}, {{$t('Доп.мероприятия')}}: {{ npa.npa.extra_measures }}</td>
                  </tr>
                  <tr>
                    <td>{{ $t('Отрасли') }}</td>
                    <td>
                      <div class="tags">
                        <template v-for="branch in npa.npa.branch_law">
                          <span class="tag" :key="branch.id">{{
                            branch.transName
                          }}</span>
                        </template>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>{{ $t('Цель проекта НПА') }}</td>
                    <td>
                      <div class="project-goal-container">
                        <div
                          id="projectGoal"
                          v-html="npa.npa.transProjectGoal"
                          class="project-goal-content"
                          :class="{
                            height_inherit: projectGoalCollapse == true
                          }"
                        ></div>
                        <div
                          v-if="
                            !projectGoalCollapse &&
                              npa.npa.transProjectGoal.length > 300
                          "
                          class="project-goal-gradient"
                        ></div>
                        <a
                          href="#projectGoal"
                          v-if="npa.npa.transProjectGoal.length > 300"
                          @click.prevent="
                            projectGoalCollapse = !projectGoalCollapse
                          "
                        >
                          <template v-if="projectGoalCollapse">{{
                            $t('Свернуть')
                          }}</template>
                          <template v-else>{{ $t('Развернуть') }}</template>
                        </a>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>{{ $t('Ключевые слова') }}</td>
                    <td>
                      <div class="tags">
                        <template v-for="keyword in npa.npa.keyword">
                          <span class="tag" :key="keyword.id">
                            #{{ keyword.transName }}
                          </span>
                        </template>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>{{ $t('Требует финансирования') }}</td>
                    <td>
                      <span
                        v-if="
                          npa.npa.funding_required &&
                            npa.npa.funding_required === true
                        "
                      >
                        {{ $t('да') }}
                      </span>
                      <span v-else>{{ $t('нет') }}</span>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      {{ $t('Затрагивает предпринимательскую деятельность') }}
                    </td>
                    <td>
                      <span
                        v-if="
                          npa.npa.entrepreneurship_affect &&
                            npa.npa.entrepreneurship_affect === true
                        "
                      >
                        {{ $t('да') }}
                      </span>
                      <span v-else>{{ $t('нет') }}</span>
                    </td>
                  </tr>
                  <tr>
                    <td>{{ $t('Ссылки на НПА') }}</td>
                    <td>
                      <div class="tags">
                        <template v-for="(link, i) in npa.npa.links">
                          <a
                            target="_blank"
                            class="tag"
                            :href="link.text"
                            :key="i"
                          >
                            {{ link.text }}
                          </a>
                        </template>
                      </div>
                    </td>
                  </tr>
                  <tr v-if="npa.jkData">
                    <td>{{ $t("Проект в ЖК") }}</td>
                    <td>
                      <div class="jk-info-block">
                            <span>
                              № {{ npa.jkData.registrationNumber }}
                              от {{ npa.jkData.publishDate }}
                            </span>
                        <br>
                        <a :href="npa.jkData.url" target="_blank" class="font-weight-bold">
                          «{{ npa.jkData.title }}»
                        </a>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div
                class="npaPromotionHistory"
                v-if="
                  npa.npaStatusConsiderationStage &&
                    npaPromotionHistories.length > 0
                "
              >
                <p align="center">
                  <a
                    @click.prevent="
                      npaPromotionHistoryCollapse = !npaPromotionHistoryCollapse
                    "
                  >
                    {{
                      $t(
                        'История продвижения проекта нормативного правового акта'
                      )
                    }}
                  </a>
                </p>
                <table v-if="npaPromotionHistoryCollapse" class="table-data">
                  <tbody>
                    <template v-for="(item, index) in npaPromotionHistories">
                      <tr v-bind:key="index">
                        <td
                          :rowspan="item.documents.length + 1"
                          class="td-title"
                        >
                          <p>{{ item.transName }}</p>
                          <p v-if="item.date">
                            {{ $t('Дата') }}:
                            {{ new Date(item.date) | dateFormat('DD.MM.YYYY') }}
                          </p>
                        </td>
                        <td>
                          <p v-if="item.descriptionType">
                            {{ item.descriptionType }}:
                            <template
                              v-if="
                                item.transDescription?.includes('http') ||
                                  item.transDescription?.includes('https')
                              "
                            >
                              <a target="_blank" :href="item.transDescription">
                                {{ item.transDescription }}
                              </a>
                            </template>
                            <template v-else>
                              {{ item.transDescription }}
                            </template>
                          </p>
                          <p v-else>
                            Источник данных: <a target="_blank" :href="`https://kenesh.kg/bills/${item.jk_id}`">сайт Жогорку Кенеша Кыргызской Республики</a>
                          </p>
                          <a
                            v-if="item.firstDoc"
                            :href="baseUrl + item.firstDoc.fullFilePath"
                            target="_blank"
                            >{{ item.firstDoc.documentType }}</a
                          >
                        </td>
                      </tr>
                      <tr
                        v-for="(document, documentIndex) in item.documents"
                        v-bind:key="documentIndex"
                      >
                        <td>
                          <a
                            :href="baseUrl + document.fullFilePath"
                            target="_blank"
                            >{{ document.documentType }}</a
                          >
                        </td>
                      </tr>
                    </template>
                  </tbody>
                </table>
                <a
                  v-if="npaPromotionHistoryCollapse"
                  @click.prevent="
                    npaPromotionHistoryCollapse = !npaPromotionHistoryCollapse
                  "
                >
                  {{ $t('Свернуть') }}
                </a>
              </div>
              <div class="npa-version">
                <v-tabs>
                  <v-tab
                    v-for="npaVersions in npa.npaVersions"
                    :key="npaVersions.id"
                  >
                    {{ npaVersions.npaVersion.version.transName }}
                  </v-tab>
                  <v-tab key="npaDocuments">
                    {{ $t('Сопроводительные документы') }}
                  </v-tab>
                  <v-tab key="npaExaminations">
                    {{ $t('Результаты специализированных видов экспертиз') }}
                  </v-tab>
                  <v-tab key="npaInitiativeGroup" v-if="showInitiativeGroupTab">
                    {{ $t('Инициативная группа') }}
                  </v-tab>
                  <v-tab-item
                    v-for="npaVersions in npa.npaVersions"
                    :key="npaVersions.id"
                  >
                    <div class="version-body">
                      <v-tabs
                        v-model="npaVersionsLangTab"
                        class="tab-text-version"
                      >
                        <v-tab :key="'kgBlock' + npaVersions.id">
                          {{ $t('Текст проекта НПА на государственном языке') }}
                          <a
                            v-if="npaVersions.npaVersion.file_kg !== null"
                            :href="
                              baseUrl +
                                npaVersions.npaVersion.fullFilesDirectoryKg
                            "
                            class="file-link"
                          >
                            <i
                              v-if="npaVersions.npaVersion.fileExtensionKg"
                              :class="
                                'pro-icon-' +
                                  npaVersions.npaVersion.fileExtensionKg
                              "
                            ></i>
                            {{
                              $t(
                                'Скачать Файл проекта НПА на государственном языке'
                              )
                            }}
                          </a>
                        </v-tab>
                        <v-tab :key="'ruBlock' + npaVersions.id">
                          {{ $t('Текст проекта НПА на официальном языке') }}
                          <a
                            v-if="npaVersions.npaVersion.file !== null"
                            :href="
                              baseUrl +
                                npaVersions.npaVersion.fullFilesDirectory
                            "
                            class="file-link"
                          >
                            <i
                              v-if="npaVersions.npaVersion.fileExtension"
                              :class="
                                'pro-icon-' +
                                  npaVersions.npaVersion.fileExtension
                              "
                            ></i>
                            {{
                              $t(
                                'Скачать Файл проекта НПА на официальном языке'
                              )
                            }}
                          </a>
                        </v-tab>
                        <NpaComments
                          :npaComments="npaVersions.npaVersionsComment"
                          :npaData="{
                            npaId: npa.npa.id,
                            npaVerId: npaVersions.npaVersion.id
                          }"
                          :editLabel="$t('Оставить комментарии к Проекту НПА')"
                          :showId="'ver' + npaVersions.npaVersion.id"
                          :getComment="getComment(false)"
                          :showFile="true"
                          :allowComment="npa.npa.status.allow_comment"
                          :commentVoting="npa.npa.status.comment_voting"
                          :allowCommentAnswer="
                            npa.npa.status.allow_comment_answer
                          "
                          :secondAllowCommentAnswer="secondAllowCommentAnswer"
                          :author="npa.npa.author.id"
                          :developer="npa.npa.developer.id"
                          :blockCommented="true"
                          :editComment="editComment"
                        />
                        <v-tab-item :key="'kgBlock' + npaVersions.id">
                          <article
                            v-for="npaVersionBlocksKg in npaVersions.npaVersionBlocksKg"
                            :key="npaVersionBlocksKg.id"
                          >
                            <div class="form-text-area" v-html="npaVersionBlocksKg.text"></div>
                            <NpaComments
                              :npaComments="
                                npaVersions.npaVersionBlocksCommentsKg[
                                  npaVersionBlocksKg.id
                                ]
                              "
                              :npaData="{
                                npaId: npa.npa.id,
                                npaVerId: npaVersions.npaVersion.id,
                                npaBlockId: npaVersionBlocksKg.id
                              }"
                              :editLabel="$t('Комментировать')"
                              :showId="'bl_kg_' + npaVersionBlocksKg.id"
                              :getComment="getComment(true)"
                              :showFile="false"
                              :allowComment="npa.npa.status.allow_comment"
                              :commentVoting="npa.npa.status.comment_voting"
                              :allowCommentAnswer="
                                npa.npa.status.allow_comment_answer
                              "
                              :secondAllowCommentAnswer="
                                secondAllowCommentAnswer
                              "
                              :author="npa.npa.author.id"
                              :developer="npa.npa.developer.id"
                              :blockCommented="npaVersionBlocksKg.commented"
                              :editComment="editComment"
                            />
                          </article>
                        </v-tab-item>
                        <v-tab-item :key="'ruBlock' + npaVersions.id">
                          <article
                            v-for="npaVersionBlocksRu in npaVersions.npaVersionBlocksRu"
                            :key="npaVersionBlocksRu.id"
                          >
                            <div class="form-text-area" v-html="npaVersionBlocksRu.text"></div>
                            <NpaComments
                              :npaComments="
                                npaVersions.npaVersionBlocksCommentsRu[
                                  npaVersionBlocksRu.id
                                ]
                              "
                              :npaData="{
                                npaId: npa.npa.id,
                                npaVerId: npaVersions.npaVersion.id,
                                npaBlockId: npaVersionBlocksRu.id
                              }"
                              :editLabel="$t('Комментировать')"
                              :showId="'bl_ru_' + npaVersionBlocksRu.id"
                              :getComment="getComment(true, true)"
                              :showFile="false"
                              :allowComment="npa.npa.status.allow_comment"
                              :commentVoting="npa.npa.status.comment_voting"
                              :allowCommentAnswer="
                                npa.npa.status.allow_comment_answer
                              "
                              :secondAllowCommentAnswer="
                                secondAllowCommentAnswer
                              "
                              :author="npa.npa.author.id"
                              :developer="npa.npa.developer.id"
                              :blockCommented="npaVersionBlocksRu.commented"
                              :editComment="editComment"
                            />
                          </article>
                        </v-tab-item>
                      </v-tabs>
                      <NpaComments
                        :npaComments="npaVersions.npaVersionsComment"
                        :npaData="{
                          npaId: npa.npa.id,
                          npaVerId: npaVersions.npaVersion.id
                        }"
                        :editLabel="
                          $t('Оставить комментарии к Проекту НПА')
                        "
                        :showId="'ver' + npaVersions.npaVersion.id"
                        :getComment="getComment(false)"
                        :showFile="true"
                        :allowComment="npa.npa.status.allow_comment"
                        :commentVoting="npa.npa.status.comment_voting"
                        :allowCommentAnswer="
                          npa.npa.status.allow_comment_answer
                        "
                        :secondAllowCommentAnswer="secondAllowCommentAnswer"
                        :author="npa.npa.author.id"
                        :developer="npa.npa.developer.id"
                        :blockCommented="true"
                        :editComment="editComment"
                      />
                    </div>
                    <div class="version-footer">
                      <div class="share-soc">
                        <div class="share-icons">
                          <Social
                            :title="npa.npa.transName"
                            :quote="npa.npa.transName"
                            :url="currentUrl"
                          />
                        </div>
                        <div class="print-version">
                          <img src="@/assets/print.png" alt="print" />
                          <a href="#!">{{ $t('Версия для печати') }}</a>
                        </div>
                      </div>
                    </div>
                  </v-tab-item>
                  <v-tab-item key="npaDocuments">
                    <ul class="npa-document-list">
                      <li
                        v-for="document in npa.npaDocuments"
                        :key="document.id"
                      >
                        <template>
                          <div class="version-body">
                            <template
                              v-if="
                                document.fileExtension === 'pdf' ||
                                  document.fileExtension === 'jpeg' ||
                                  document.fileExtension === 'jpg' ||
                                  document.fileExtension === 'png'
                              "
                            >
                              <a
                                class="file-link"
                                :href="baseUrl + document.fullFilesDirectory"
                                target="_blank"
                              >
                                <i
                                  v-if="document.fileExtension"
                                  :class="'pro-icon-' + document.fileExtension"
                                ></i>
                                {{ document.type.transName }}
                              </a>
                            </template>
                            <template v-else>
                              <a
                                class="file-link"
                                @click="
                                  previewDocumentDialog(document.id, true)
                                "
                              >
                                <i
                                  v-if="document.fileExtension"
                                  :class="'pro-icon-' + document.fileExtension"
                                ></i>
                                {{ document.type.transName }}
                              </a>
                              <v-dialog
                                v-model="previewDocsModal[document.id]"
                                max-width="1200"
                              >
                                <v-card class="modal">
                                  <div class="modal-head">
                                    {{ document.type.transName }}
                                    <v-btn
                                      color="modal-close"
                                      @click="
                                        previewDocumentDialog(
                                          document.id,
                                          false
                                        )
                                      "
                                    >
                                      <span class="pro-icon-close1"></span>
                                    </v-btn>
                                  </div>
                                  <div class="modal-body">
                                    <VueDocPreview
                                      :value="
                                        baseUrl + document.fullFilesDirectory
                                      "
                                      type="office"
                                    />
                                  </div>
                                </v-card>
                              </v-dialog>
                            </template>
                          </div>
                        </template>
                      </li>
                    </ul>
                  </v-tab-item>
                  <v-tab-item key="npaExaminations">
                    <template v-if="isLoggedIn">
                      <div v-if="npa.canAddExamination" class="version-head npa-examinations">
                        <Examinations
                          ref="examination"
                          v-if="editable || editableExamination"
                          @setDataExaminations="getExaminationsData($event)"
                        />
                      </div>
                    </template>
                    <template v-else>
                      <div class="mt-6">
                        {{ $t('Чтобы добавить результаты специализированных видов экспертиз нужно') }}
                        <router-link class="font-weight-bold" active-class="active" :to="$i18nRoute({ name: 'login' })">
                          {{ $t('авторизоваться') }}
                        </router-link>
                        {{ $t('или') }}
                        <router-link class="font-weight-bold" active-class="active" :to="$i18nRoute({ name: 'register' })">
                          {{ $t('зарегистрироваться') }}
                        </router-link>
                      </div>
                    </template>
                    <div class="version-body">
                      <div class="form-group files">
                        <v-simple-table>
                          <template v-slot:default>
                            <thead>
                              <tr>
                                <th class="text-left">
                                  {{ $t('Наименование') }}
                                </th>
                                <th>
                                  {{ $t('Категории') }}
                                </th>
                                <th class="text-left">
                                  {{ $t('Комментарии') }}
                                </th>
                                <th class="text-left">
                                  {{ $t('Автор') }}
                                </th>
                                <th class="text-left">
                                  {{ $t('Файлы') }}
                                </th>
                                <th
                                  v-if="editable || editableExamination"
                                  class="text-left"
                                >
                                  {{ $t('') }}
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr
                                v-for="examination in npa.npaExaminations"
                                :key="examination.id"
                              >
                                <td>{{ examination.name }}</td>
                                <td>{{ examination.examination_categories.length ? examination.examination_categories.map(c => c.transName).join(', ') : '' }}</td>
                                <td>{{ examination.comment }}</td>
                                <td>
                                  {{ examination.user.first_name }}
                                  {{ examination.user.second_name }}
                                  {{ examination.user.last_name }}
                                </td>
                                <td>
                                  <div v-for="document in examination.documents" :key="document.id">
                                    <template v-if="document.fileExtension === 'pdf'">
                                      <a class="file-link" :href="baseUrl + document.fullFilesDirectory" target="_blank">
                                        <i v-if="document.fileExtension" :class="'pro-icon-' + document.fileExtension"></i>
                                        {{ document.name }}
                                      </a>
                                    </template>
                                    <template v-else>
                                      <a @click="previewDocumentDialog(document.id,true)">
                                        <i v-if="document.fileExtension" :class="'pro-icon-' + document.fileExtension"></i>
                                        {{ document.name }}
                                      </a>
                                      <v-btn
                                        v-if="isLoggedIn && examination.user.id === user.id"
                                        fab
                                        dark
                                        x-small
                                        @click="deleteExaminationDocument(examination.id, document.id)">
                                        <v-icon dark>mdi-close</v-icon>
                                      </v-btn>
                                      <v-dialog v-model="previewDocsModal[document.id]" max-width="1200">
                                        <v-card class="modal">
                                          <div class="modal-head">
                                            {{ document.name }}
                                            <v-btn
                                              color="modal-close"
                                              @click="previewDocumentDialog(document.id,false)">
                                              <span class="pro-icon-close1"></span>
                                            </v-btn>
                                          </div>
                                          <div class="modal-body">
                                            <VueDocPreview :value=" baseUrl + document.fullFilesDirectory" type="office"/>
                                          </div>
                                        </v-card>
                                      </v-dialog>
                                    </template>
                                  </div>
                                </td>
                                <td v-if="editable || editableExamination">
                                  <v-btn
                                    class="mx-2"
                                    fab
                                    dark
                                    small
                                    @click="deleteExamination(examination.id)"
                                  >
                                    <v-icon dark>
                                      mdi-close
                                    </v-icon>
                                  </v-btn>
                                </td>
                              </tr>
                            </tbody>
                          </template>
                        </v-simple-table>
                      </div>
                    </div>
                  </v-tab-item>
                  <v-tab-item key="npaInitiativeGroup" v-if="showInitiativeGroupTab">
                    <div class="version-body">
                      <div class="table-overflow">
                        <table class="table table-data">
                          <tbody>
                            <tr>
                              <td>{{ $t('Наименование') }}</td>
                              <td>{{ initiativeGroupData.transName }}</td>
                            </tr>
                            <tr>
                              <td>{{ $t('Регистрационный номер') }}</td>
                              <td>{{ initiativeGroupData.reg_number }}</td>
                            </tr>
                            <tr>
                              <td>{{ $t('Дата регистрации') }}</td>
                              <td>
                                <template v-if="initiativeGroupData.reg_date">
                                  {{ new Date(initiativeGroupData.reg_date) | dateFormat('DD.MM.YYYY') }}
                                </template>
                              </td>
                            </tr>
                            <tr>
                              <td>{{ $t('Наименование органа, выдавшего свидетельство о регистрации') }}</td>
                              <td>{{ initiativeGroupData.reg_authority }}</td>
                            </tr>
                            <tr>
                              <td>{{ $t('Данные о руководителях') }}</td>
                              <td v-html="initiativeGroupData.leaders"></td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </v-tab-item>
                </v-tabs>
              </div>
            </div>
          </div>
        </div>
      </v-container>
    </div>
  </div>
</template>

<script>
import Search from '@/model/search'
import Subscription from '@/model/subs'
import Social from '@/components/Social'
import NpaReport from '@/components/npa/NpaReport'
import { mapMutations } from 'vuex'
import NpaComments from '@/components/npa/NpaComments'
import VueDocPreview from 'vue-doc-preview'
import moment from 'moment'
import { Trans } from '@/plugins/Translation'
import Examinations from '@/components/npa/Examinations.vue'
import Npa from '@/store/modules/getNpaData'
import NpaInitiative from '@/components/npa/NpaInitiative.vue'

export default {
  components: {
    NpaInitiative,
    Examinations,
    NpaComments,
    VueDocPreview,
    Social,
    NpaReport
  },
  data() {
    return {
      npaReportDialog: false,
      npa: null,
      comments: Array,
      isSubscribed: false,
      showComment: {},
      showVersionComment: false,
      loadComment: false,
      breadcrumbs: [],
      baseUrl: process.env.VUE_APP_BACK_URL,
      currentUrl: '',
      previewDocsModal: [],
      historiesMenu: false,
      npaStagePopup: false,
      npaVersionsLangTab: null,
      dateDiscussStep: null,
      dateConsideredStep: null,
      title: '',
      description: '',
      keywords: '',
      projectGoalCollapse: false,
      npaPromotionHistory: {},
      npaPromotionHistories: [],
      npaPromotionHistoryCollapse: false,
      secondAllowCommentAnswer: false,
      userNpaIds: [],
      editComment: false,
      editable: false,
      editableExamination: true,
      user: null
    }
  },
  metaInfo() {
    return {
      title: this.title,
      meta: [
        {
          vmid: 'description',
          name: 'description',
          content: this.description
        },
        {
          vmid: 'keywords',
          name: 'keywords',
          content: this.keywords
        }
      ]
    }
  },
  computed: {
    isLoggedIn() {
      return this.$store.getters.isLoggedIn
    },
    initiativeGroupData() {
      if (!this.npa || !this.npa.npa || !this.npa.npa.author) {
        return {}
      }

      return this.npa.npa.author.initiative_group || {}
    },
    showInitiativeGroupTab() {
      if (!this.npa || !this.npa.npa || !this.npa.npa.status || !this.npa.npa.author) {
        return false
      }

      return this.npa.npa.status.id === 12
    }
  },
  created() {
    // загружаем данные, когда представление создано
    // и данные реактивно отслеживаются
    this.userNpaIds = JSON.parse(localStorage.getItem('userNpaIds') || '[]')
    this.fetchData()
    this.currentUrl = window.location.href
    this.$store.dispatch('fetchAnswerItems')
  },
  watch: {
    // при изменениях маршрута запрашиваем данные снова
    $route: 'fetchData'
  },
  mounted() {
    this.user = this.$store.getters.checkUser
  },
  methods: {
    ...mapMutations(['setLoading']),
    fetchData() {
      const parsedNpaId = Number.parseInt(this.$route.params.id, 10)
      const npaId = Number.isInteger(parsedNpaId) && parsedNpaId > 0 ? parsedNpaId : null

      if (npaId) {
        this.userNpaIds.push({
          id: npaId,
          datetime: new Date()
        })
        localStorage.setItem('userNpaIds', JSON.stringify(this.userNpaIds))
      }

      this.setLoading(true)
      let self = this;
      Search.getNpa(this.$route.params.id)
        .then((response) => {
          this.npa = response.data
          this.npaPromotionHistory = response.data.npaPromotionHistory
          this.npaPromotionHistories = response.data.npaPromotionHistories
          this.dateDiscussStep = moment(this.npa.discussStep.date).format('DD.MM.YYYY')
          this.dateConsideredStep = moment(this.npa.consideredStep.date).format('DD.MM.YYYY')
          this.secondAllowCommentAnswer = response.data.secondAllowCommentAnswer
          this.editComment = response.data.editComment

          if (this.isLoggedIn) {
            Subscription.isSubscribed(this.npa.npa.id)
              .then((response) => {
                this.isSubscribed = response.data.result
              })
              .catch((error) => {
                console.log(error)
              })
          }
          this.title = this.npa.npa.transName
          this.description = this.npa.npa.project_goal.replace(/(<([^>]+)>)/gi, "")

          this.npa.npa.keyword.forEach(function (keyword) {
            self.keywords = self.keywords + ' ' + keyword.transName
          })

          this.setLoading(false)
          const breadcrumb = {}
          breadcrumb.text = this.npa.npa.transName
          breadcrumb.disabled = true
          this.breadcrumbs = [
            {text: this.$i18n.t('Главная'), disabled: false, href: Trans.currentLocaleUrl + '/'},
            {
              text: this.$i18n.t('Расширенный поиск проекта'),
              disabled: false,
              href: Trans.currentLocaleUrl + '/search-npa'
            }
          ]
          this.breadcrumbs.push(breadcrumb)
        }).catch((error) => {
        this.$router.push(Trans.i18nRoute({
          name: 'error',
          params: {
            status: error.response.status
          }
        }))
        this.setLoading(false)
      })
    },
    previewDocumentDialog(id, flag) {
      this.$set(this.previewDocsModal, id, flag)
    },
    getComment(isBlock, isRu = false) {
      let query = this.$route.query

      if (!query) return false

      if (query.block && isBlock) {
        if (query.block.indexOf('ru') !== -1 && isRu) {
          this.npaVersionsLangTab = 1
          return true
        }

        return !isRu
      }

      if (!query.block && !isBlock) {
        return true
      }

      return false
    },
    subscribe() {
      if (this.isLoggedIn) {
        Subscription.subscribeNpa(this.npa.npa.id)
          .then((response) => {
            alert(this.$i18n.t('Вы успешно подписаны на обновления'))
            if (response.data.result === 'success') this.isSubscribed = !this.isSubscribed
          })
          .catch((error) => {
            console.log(error)
          })
      } else {
        alert(this.$i18n.t('Вам необходимо авторизоваться или зарегистрироваться'))
      }
    },
    unsubscribe() {
      if (this.isLoggedIn) {
        Subscription.unsubscribeNpa(this.npa.npa.id)
          .then((response) => {
            alert(this.$i18n.t('Подписка успешно отменена'))
            if (response.data.result === 'success') this.isSubscribed = !this.isSubscribed
          })
          .catch((error) => {
            console.log(error)
          })
      } else {
        alert(this.$i18n.t('Вам необходимо авторизоваться или зарегистрироваться'))
      }
    },
    editDialog() {
      if (this.npa.npa.status.review_result_report === true) {
        this.npaReportDialog = true
      }
    },
    goToPromotionHistory() {
      this.$vuetify.goTo('.npaPromotionHistory')
    },
    getExaminationsData(examinationsList) {
      this.examinationsData = Array.isArray(examinationsList) ? examinationsList : Object.values(examinationsList);

      let fd = new FormData();

      this.examinationsData.forEach((element, index) => {
        if (element.documents) {
          element.documents.forEach((doc, index) => {
            fd.append(`npa_examination_type[documents][${index}][file]`, doc.file);
            fd.append(`npa_examination_type[documents][${index}][name]`, doc.name);
          })
        }
        if (element.name) {
          fd.append(`npa_examination_type[name]`, element.name);
        }
        if (element.comment !== undefined) {
          fd.append(`npa_examination_type[comment]`, element.comment);
        }

        if (element.categories.length) {
          fd.append(`npa_examination_type[categories]`, element.categories);
        }
      });

      Npa.addNpaExamination(fd, this.npa.npa.id).then((response) => {
        let result = response.data;
        Search.getNpa(result.npa).then((response) => {
          this.setLoading(true);
          this.npa = response.data;
          this.$refs.examination.resetExamination();
          this.setLoading(false);
        });
      });
    },
    //удаляем экспертизу
    deleteExamination(id) {
      if (!confirm(this.confirmMessage)) {
        return
    }
      Npa.deleteNpaExamination(this.npa.npa.id, id).then((response) => {
        let result = response.data
        Search.getNpa(result.npa).then((response) => {
          this.setLoading(true)
          this.npa = response.data
          this.setLoading(false)
        })
      })
    },
    //удаляем документ экспертизы
    deleteExaminationDocument(examinationId, documentId) {
      if (!confirm(this.confirmMessage)) {
        return
      }
      Npa.deleteNpaExaminationDocument(examinationId, documentId).then((response) => {
        let result = response.data
        Search.getNpa(result.npa).then((response) => {
          this.setLoading(true)
          this.npa = response.data
          this.setLoading(false)
        })
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.v-menu__content {
  .history-list {
    max-width: 300px;
    max-height: 300px;
    overflow-y: auto;

    .v-list-item {
      min-height: 10px !important;
    }
  }
}

.npaPromotionHistory {
  margin-bottom: 40px;

  .table-data {
    margin-bottom: 15px;
  }
}
</style>
